/* ============================================================
   Vergleichsseite eb-vs-* — Mikrointeraktionen
   Vanilla JS, progressive enhancement:
   - Scroll-Reveal (IntersectionObserver)
   - Kassenbon-Summen zählen beim Einscrollen hoch (de-DE-Format)
   - BBK-Häkchen ticken nacheinander ein
   - FAQ-Accordion öffnet/schließt weich (details/summary-basiert)
   Ohne JS/IO bleibt alles statisch sichtbar; prefers-reduced-motion
   deaktiviert jede Animation. Re-Init pro Section im Theme-Editor
   (shopify:section:load), Elemente werden gegen Doppel-Bindung markiert.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ebVsInit) return;
  window.__ebVsInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var canAnimate = !reduceMotion && hasIO;

  var revealIO = null;
  var countIO = null;
  var bbkIO = null;

  if (canAnimate) {
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        revealIO.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countIO.unobserve(entry.target);
        animateCount(entry.target);
      });
    }, { threshold: 0.4 });

    bbkIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        bbkIO.unobserve(entry.target);
        entry.target.classList.add('is-ticking');
      });
    }, { threshold: 0.35 });
  }

  function animateCount(el) {
    if (el.__vsCounted) return;
    el.__vsCounted = true;
    var raw = (el.getAttribute('data-vs-count') || '').replace(/\./g, '').replace(',', '.');
    var target = parseFloat(raw);
    if (isNaN(target)) return;
    var decimals = parseInt(el.getAttribute('data-vs-decimals') || '2', 10);
    var fmt = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
    var duration = 1100;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
      el.textContent = fmt.format(target * eased);
      if (p < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = fmt.format(target);
      }
    }
    window.requestAnimationFrame(step);
  }

  function bindAccordion(details) {
    var summary = details.querySelector('summary');
    var content = details.querySelector('[data-vs-acc-content]');
    if (!summary || !content || summary.__vsBound) return;
    summary.__vsBound = true;

    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

    summary.addEventListener('click', function (event) {
      if (reduceMotion || typeof content.animate !== 'function') {
        /* Nativ togglen lassen, nur ARIA nachziehen */
        window.setTimeout(function () {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        }, 0);
        return;
      }
      event.preventDefault();
      if (details.__vsBusy) return;
      details.__vsBusy = true;

      if (details.open) {
        /* Schließen: Höhe -> 0, dann [open] entfernen */
        content.style.overflow = 'hidden';
        var closeAnim = content.animate(
          [
            { height: content.scrollHeight + 'px', opacity: 1 },
            { height: '0px', opacity: 0 }
          ],
          { duration: 240, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
        );
        closeAnim.onfinish = function () {
          content.style.overflow = '';
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
          details.__vsBusy = false;
        };
      } else {
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
        content.style.overflow = 'hidden';
        var openAnim = content.animate(
          [
            { height: '0px', opacity: 0 },
            { height: content.scrollHeight + 'px', opacity: 1 }
          ],
          { duration: 280, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
        );
        openAnim.onfinish = function () {
          content.style.overflow = '';
          details.__vsBusy = false;
        };
      }
    });
  }

  function initScope(scope) {
    var roots = [];
    if (scope.classList && scope.classList.contains('eb-vs')) {
      roots.push(scope);
    }
    Array.prototype.forEach.call(scope.querySelectorAll('.eb-vs'), function (r) { roots.push(r); });
    if (!roots.length) return;

    roots.forEach(function (root) {
      if (canAnimate) {
        root.classList.add('vs-anim-ready');
        Array.prototype.forEach.call(root.querySelectorAll('[data-vs-reveal]'), function (el) {
          if (el.__vsObserved) return;
          el.__vsObserved = true;
          revealIO.observe(el);
        });
        Array.prototype.forEach.call(root.querySelectorAll('[data-vs-count]'), function (el) {
          if (el.__vsObserved) return;
          el.__vsObserved = true;
          countIO.observe(el);
        });
        Array.prototype.forEach.call(root.querySelectorAll('[data-vs-bbk]'), function (panel) {
          if (panel.__vsObserved) return;
          panel.__vsObserved = true;
          bbkIO.observe(panel);
        });
      } else {
        /* Ohne Animation: Endzustand sofort zeigen */
        Array.prototype.forEach.call(root.querySelectorAll('[data-vs-bbk]'), function (panel) {
          panel.classList.add('is-ticking');
        });
      }

      Array.prototype.forEach.call(root.querySelectorAll('details[data-vs-acc]'), bindAccordion);
      syncFolds();
    });
  }

  /* Kassenbon-Folds: Markup-Default ist offen (No-JS/Desktop). Auf Mobile
     einklappen, beim Verlassen des Mobile-Bereichs (Rotation, Resize) wieder
     oeffnen — ab 750px ist die Summary versteckt, ein geschlossenes details
     waere sonst unsichtbar und nicht mehr oeffenbar. */
  var foldMq = window.matchMedia('(max-width: 749px)');
  function syncFolds() {
    Array.prototype.forEach.call(document.querySelectorAll('details[data-vs-fold]'), function (d) {
      if (foldMq.matches) d.removeAttribute('open');
      else d.setAttribute('open', '');
    });
  }
  if (foldMq.addEventListener) foldMq.addEventListener('change', syncFolds);
  else if (foldMq.addListener) foldMq.addListener(syncFolds);

  function init() {
    initScope(document);
    /* Sicherheits-Fallback: Wenn die IntersectionObserver aus irgendeinem Grund
       nicht feuern (bfcache, Preview-Umgebung, Timing), wird nach 2s alles
       sichtbar geschaltet und die Zaehler laufen direkt. Sichtbarkeit > Animation. */
    setTimeout(function () {
      document.documentElement.classList.add('vs-reveal-fallback');
      Array.prototype.forEach.call(document.querySelectorAll('[data-vs-count]'), animateCount);
      Array.prototype.forEach.call(document.querySelectorAll('[data-vs-bbk]'), function (panel) {
        panel.classList.add('is-ticking');
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-vs-reveal]'), function (el) {
        el.classList.add('is-in');
      });
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme-Editor: Section wird neu gerendert -> nur diese Section initialisieren */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initScope(event.target);
  });
})();
